import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FilterStateService } from '@services/filter-state.service';
import { SectionHeaderComponent } from '@shared/section-header/section-header.component';
import { IconSanitizerService, TabItemComponent, TabViewComponent } from 'ngx-lib';
import { IFilterValueBuildings } from '../buildings-filters/buildings-filter.config';
import { BuildingsFiltersComponent } from '../buildings-filters/buildings-filters.component';
import { BuildingsListComponent } from '../buildings-list/buildings-list.component';
import { BuildingsMapComponent } from '../buildings-map/buildings-map.component';

@Component({
    selector: 'app-buildings-main',
    templateUrl: './buildings-main.component.html',
    styleUrls: ['./buildings-main.component.scss'],
    imports: [
        SectionHeaderComponent,
        TabViewComponent,
        TabItemComponent,
        BuildingsFiltersComponent,
        BuildingsListComponent,
        BuildingsMapComponent
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: FilterStateService,
            useClass: FilterStateService<IFilterValueBuildings>
        }
    ]
})
export class BuildingsMainComponent implements OnInit {
    listIcon?: SafeHtml;
    mapIcon?: SafeHtml;
    currentTab = 'List';
    plusIcon?: SafeHtml;

    private readonly router = inject(Router);
    private readonly iconSanitizer = inject(IconSanitizerService);

    ngOnInit(): void {
        this.listIcon = this.iconSanitizer.getIcon('list');
        this.mapIcon = this.iconSanitizer.getIcon('map');
        this.plusIcon = this.iconSanitizer.getIcon('plus');
    }

    onCreateNewBuildingClicked() {
        this.router.navigate([`/buildings-edit`]);
    }
}
